import moment from "moment";

/**
 *
 * @param {moment} fecha
 * @param {Object} valor
 * @returns  Fecha de vencimiento calculada según el periodo especificado
 */
export const calcularVencimientoPorPeriodo = (fecha, valor) => {
  switch (valor.periodo) {
    case "diario":
      return moment(fecha).add(1, "day");
    case "semanal":
      return moment(fecha).add(1, "week");
    case "quincenal":
      return moment(fecha).add(15, "days");
    case "mensual":
      return moment(fecha).add(1, "month");
    case "bimestral":
      return moment(fecha).add(2, "months");
    case "trimestral":
      return moment(fecha).add(3, "months");
    case "semestral":
      return moment(fecha).add(6, "months");
    case "anual":
      return moment(fecha).add(1, "year");
    case "bianual":
      return moment(fecha).add(2, "years");
    default:
      // En caso de que el periodo no sea válido, usar días como fallback
      return moment(fecha).add(valor.dias, "days");
  }
};
